import home from '@/routes/Home';

export default home;
